import React from 'react';

import styled, { keyframes, css } from 'styled-components';

const animateOpacity = keyframes`
    0%, 100%{
        opacity: 1;
    } 
    50%{
        opacity: 0;
    }
`;

const Text = styled.div(
  ({ theme }) => css`
    animation: ${animateOpacity} 0.8s infinite;
    ${theme.textTypes['Subtitle-1-w500']}
    color: ${theme.colors.gbrand500};
    font-weight: 500;
    font-size: 14px;
    width: 100%;
    text-align: center;
    margin-bottom: 32px;
    margin-top: -12px;
    padding-bottom: 32px;
  `
);

const LoadingLastMovements = () => {
  return <Text>Cargando...</Text>;
};

export default LoadingLastMovements;
